import _ from "lodash";
import { routes } from "../../routes";
import { getRouters } from "@/api/menu";

const permissionModule = function () {
  return {
    namespaced: true,

    state: {
      routes: [],
      addRoutes: [],
      defaultRoutes: [],
      topbarRouters: [],
      sidebarRouters: [],
      subSystemId: "", //子系统id
      subSystemName: "",
      routeTabs: [],
    },
    mutations: {
      SET_ROUTES: (state, routes) => {
        state.addRoutes = routes;
        state.routes = routes.concat(routes);
      },
      SET_DEFAULT_ROUTES: (state, routes) => {
        state.defaultRoutes = routes.concat(routes);
      },
      SET_TOPBAR_ROUTES: (state, routes) => {
        // 顶部导航菜单默认添加统计报表栏指向首页
        const index = [
          // {
          // path: 'index',
          // meta: {
          //   title: '首页',
          //   icon: 'dashboard'
          //       }
          // }
        ];
        state.topbarRouters = routes.concat(index);
      },
      SET_SIDEBAR_ROUTERS: (state, routes) => {
        state.sidebarRouters = routes;
      },
      SET_SUB_SYSTEM_ID: (state, id) => {
        state.subSystemId = id;
        console.log("state.subSystemId----->", id);
      },
      SET_SUB_SYSTEM_NAME: (state, name) => {
        state.subSystemName = name;
      },
      SET_ROUTE_TABS: (state, routes) => {
        state.routeTabs = routes;
        // const index =  state.routeTabs.findIndex(item=>item.path === route.path)
        // if(index < 0 ){state.routeTabs = state.routeTabs.concat([route])}
      },
    },
    actions: {
      // 生成路由
      GenerateRoutes({ commit, state }) {
        return new Promise((resolve) => {
          // 向后端请求路由数据
          getRouters({ type: state.subSystemId || 2 }).then((res) => {
            if (
              res.data &&
              res.data[0] &&
              res.data[0].children &&
              res.data[0].children[0]
            ) {
              commit("SET_ROUTES", res.data[0].children);
              resolve(res.data[0].children[0]);
            } else {
              resolve("");
            }
          });
        });
      },
    },
  };
};
// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
  return asyncRouterMap.filter((route) => {
    if (type && route.children) {
      route.children = filterChildren(route.children);
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type);
    } else {
      delete route["children"];
      delete route["redirect"];
    }
    return true;
  });
}

function filterChildren(childrenMap, lastRouter = false) {
  var children = [];
  childrenMap.forEach((el, index) => {
    if (el.children && el.children.length) {
      if (el.component === "ParentView") {
        el.children.forEach((c) => {
          c.path = el.path + "/" + c.path;
          if (c.children && c.children.length) {
            children = children.concat(filterChildren(c.children, c));
            return;
          }
          children.push(c);
        });
        return;
      }
    }
    if (lastRouter) {
      el.path = lastRouter.path + "/" + el.path;
    }
    children = children.concat(el);
  });
  return children;
}

export const loadView = (view) => {
  // 路由懒加载
  return (resolve) => require([`@/views/${view}`], resolve);
};
export default permissionModule();
